import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";

// Layout
import AuthLayout from "../Layout/authLayout";
import RootLayout from "../Layout/rootLayout";

// Auth
import Login from "../Authentication/Login";
import ForgotPassword from "../Authentication/ForgotPassword";
import ForgotPattern from "../Authentication/ForgotPattern";
import ResetPassword from "../Authentication/ResetPassword";
import ResetPattern from "../Authentication/ResetPattern";

// Pages
import Dashboard from "../pages/Dashboard";
import Settings from "../pages/securitySettings";
import SiteSettings from "../pages/siteSettings/SiteSettings";
import PagenotFound from "../pages/common/pagenotFound";
import LoginHistory from "../pages/LoginHistory";
import WhiteIp from "../pages/WhiteIp";
import BlockIp from "../pages/BlockIp";
import Cms from "../pages/CMS-Management";
import NotWhitelisted from "../pages/common/WhiteList";
import IpBlocked from "../pages/common/ipBlocked";
import FaqManager from "../pages/Faq";
import FeeManagement from "../pages/Fee-Management";
import HomeAbout from "../pages/Homepage-Management/About/AbouUs";
import HomeBanner from "../pages/Homepage-Management/Banner/Banner";
import HomeFeatures from "../pages/Homepage-Management/Features/Features";
import HomeCardList from "../pages/Homepage-Management/Cardlist/CardList";
import HomeDownload from "../pages/Homepage-Management/Download-Roupay/Download";
import Usermanagement from "../pages/Usermanagement/UserDetail";
import SingleUserHistory from "../pages/Usermanagement/SingleUserHistory";
import InternalTransactionHistory from "../pages/History/Internal TransactionHistory/InternalTransactionHistory";
import TotalReferralhistory from "../pages/referral-management/tabs/ReferralHistory";
import EditCurrency from "../pages/Fee-Management/tabs/editCurrency";
import Referralreward from "../pages/referral-management/tabs/Referralreward";
import Rewardupdatehistory from "../pages/referral-management/tabs/Rewardupdatehistory";

// Withdraw Management
import EthWithdraw from "../pages/withdraw-management/tabs/EthWithdraw";
import BnbWithdraw from "../pages/withdraw-management/tabs/BnbWithdraw";
import TRXWithdraw from "../pages/withdraw-management/tabs/TRXWithdraw";
import POLWithdraw from "../pages/withdraw-management/tabs/POLWithdraw";

// Deposit Management
import ETHDepositHistorys from "../pages/Deposit-Management/tabs/ETHDeposit";
import BNBDepositHistorys from "../pages/Deposit-Management/tabs/BNBDeposit";
import TRXDepositHistorys from "../pages/Deposit-Management/tabs/TRXDeposit";
import SOLWithdraw from "../pages/withdraw-management/tabs/SOLwithdraw";
import POLDepositHistorys from "../pages/Deposit-Management/tabs/POLDeposit";
import SOLDepositHistorys from "../pages/Deposit-Management/tabs/SOLDeposit";
import DeleteRequestAccount from "../pages/Usermanagement/DeleteAccount";
import DeletedAccountHistory from "../pages/Usermanagement/DeleteAccountHistory";
import RouWithdraw from "../pages/withdraw-management/tabs/RouWithdraw";
import ROUDeposit from "../pages/Deposit-Management/tabs/ROUDeposit";


//Sub Admin
import SubAdminHistory from "../pages/SubAdmin/SubAdminHistory";
import SubAdmin from "../pages/SubAdmin/SubAdmin";
import AddSubAdmin from "../pages/SubAdmin/AddSubAdmin";

//Chart Currency
import Chartcurrency from "../pages/Chart currency/listchartcurrency";
import EditpricesCurrency from "../pages/Chart currency/EditpricesCurrency"

//CoreWallect
import Corewalletbalance from "../pages/Core wallet/corewalletbalance";
import CorePOLHistory from "../pages/Core wallet/Corewalletdeposit/POLHistory";
import CoreBNBHistory from "../pages/Core wallet/Corewalletdeposit/BNBHistory";
import CoreETHHistory from "../pages/Core wallet/Corewalletdeposit/ETHHistory";
import CoreSOLHistory from "../pages/Core wallet/Corewalletdeposit/SOLHistory";
import CoreTRXHistory from "../pages/Core wallet/Corewalletdeposit/TRXHistory";
import TopupHistory from "../pages/History/TopupHistory/TopupHistory";
import CardDepositHistory from "../pages/History/CardDepositHistory/CardDepositHistory";
import CardSpendHistory from "../pages/History/CardDepositHistory/CardSpendHistory";
import SupportTicket from "../pages/SupportTicket";
import TicketCategory from "../pages/SupportTicket/tab/TicketCategory";
import AddTicketCategory from "../pages/SupportTicket/tab/AddTicketCategory";
import TicketChat from "../pages/SupportTicket/tab/TicketChat";
import BlockedUsers from "../pages/Usermanagement/BlockedUsers";
import ReferralPending from "../pages/referral-management/tabs/ReferralPending";
import AdminWithdrawFee from "../pages/Admin-Fee-Management/adminFee";
import AdminFeeHistory from "../pages/Admin-Fee-Management/FeeTransactionHistory";
import BlockedUserHistory from "../pages/Usermanagement/AdminBlockedUsers";
import CardRefundHistory from "../pages/History/CardDepositHistory/CardRefundHistory";
import CashbackHistory from "../pages/referral-management/tabs/CashbackHistory";
import CashbackMissedHistory from "../pages/referral-management/tabs/CashbackMissed";
import SingleUserReferralHistory from "../pages/Usermanagement/ReferralHistory";
import UserCashbackHistory from "../pages/Usermanagement/UserCashbackHistory";
import UserCashbackMissed from "../pages/Usermanagement/UserCashbackMissed";
import Check from "../pages/withdraw-management/tabs/Check";
import CardManagement from "../pages/CMS-Management/card-caontent";
import NotificationHistoryTable from "../pages/notification/tabs/NotificationList";
import ReferralEdit from "../pages/referral-management/tabs/ReferralEdit";


export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route>
            <Route path="*" element={<PagenotFound />} />
            <Route path="/not-authorized" element={<NotWhitelisted />} />
            <Route path="/blocked" element={<IpBlocked />} />
            <Route path="/Check" element={<Check />} />


            <Route element={<AuthLayout />}>
                <Route index element={<Login />} />
                <Route path="/RPAYshdbeLLaw/:authCode" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/forgot-pattern" element={<ForgotPattern />} />
                <Route path="/reset-password/:id" element={<ResetPassword />} />
                <Route path="/reset-pattern/:id" element={<ResetPattern />} />
            </Route>

            <Route path="/" element={<RootLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/user-management" element={<Usermanagement />} />
                <Route path="/deleted-Account" element={<DeleteRequestAccount />} />
                <Route path="/deleted-Account-history" element={<DeletedAccountHistory />} />
                <Route path="/blocked-users" element={<BlockedUsers />} />

                <Route path="/SingleUserHistory/:id" element={<SingleUserHistory />} />
                <Route path="/internaltransactionhistory" element={<InternalTransactionHistory />} />
                <Route path="/TopupHistory" element={<TopupHistory />} />
                <Route path="/CardDepositHistory" element={<CardDepositHistory />} />
                <Route path="/CardSpendHistory" element={<CardSpendHistory />} />
                <Route path="/refund-history" element={<CardRefundHistory />} />
                <Route path="/admin-blocked-users" element={<BlockedUserHistory />} />
                <Route path="/singleuser-referral-history/:id/:level" element={<SingleUserReferralHistory />} />
                <Route path="/user-cashback/:id/:level/:type" element={<UserCashbackHistory />} />
                <Route path="/user-cashback-missed/:id/:level/:type" element={<UserCashbackMissed />} />



                <Route path="/editCurrency/:id" element={<EditCurrency />} />
                <Route path="/allowed-ips" element={<WhiteIp />} />
                <Route path="/blocked-ips" element={<BlockIp />} />
                <Route path="/login-history" element={<LoginHistory />} />
                <Route path="/site-settings" element={<SiteSettings />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/cms" element={<Cms />} />
                <Route path="/faq" element={<FaqManager />} />
                <Route path="/card-content" element={<CardManagement />} />


                <Route path="/fee-management" element={<FeeManagement />} />
                <Route path="/about" element={<HomeAbout />} />
                <Route path="/banner" element={<HomeBanner />} />
                <Route path="/features" element={<HomeFeatures />} />
                <Route path="/card-list" element={<HomeCardList />} />
                <Route path="/download" element={<HomeDownload />} />
                <Route path="/admin-fee" element={<AdminWithdrawFee />} />
                <Route path="/platformfee-history" element={<AdminFeeHistory />} />
                <Route path="/admin-reward-edit-history" element={<ReferralEdit />} />



                <Route path="/Send/ETH" element={<EthWithdraw />} />
                <Route path="/Send/BNB" element={<BnbWithdraw />} />
                <Route path="/Send/TRX" element={<TRXWithdraw />} />
                <Route path="/Send/POL" element={<POLWithdraw />} />
                <Route path="/send/SOL" element={<SOLWithdraw />} />
                <Route path="/Send/ROU" element={<RouWithdraw />} />



                <Route path="/receive/ETH" element={<ETHDepositHistorys />} />
                <Route path="/receive/BNB" element={<BNBDepositHistorys />} />
                <Route path="/receive/TRX" element={<TRXDepositHistorys />} />
                <Route path="/receive/POL" element={<POLDepositHistorys />} />
                <Route path="/receive/SOL" element={<SOLDepositHistorys />} />
                <Route path="/receive/ROU" element={<ROUDeposit />} />



                <Route path="/deleted-Account" element={<DeleteRequestAccount />} />


                <Route path="/referralreward" element={<Referralreward />} />
                <Route path="/rewardupdatehistory" element={<Rewardupdatehistory />} />
                <Route path="/totalreferralhistory" element={<TotalReferralhistory />} />
                <Route path="/reward-pending" element={<ReferralPending />} />
                <Route path="/cashback-history" element={<CashbackHistory />} />
                <Route path="/cashback-missed" element={<CashbackMissedHistory />} />


                <Route path="/SubAdmin" element={<SubAdmin />} />
                <Route path="/Addsubadmin" element={<AddSubAdmin />} />
                <Route path="/SubAdminHistory/:id" element={<SubAdminHistory />} />


                <Route path="/Chartcurrency" element={<Chartcurrency />} />
                <Route path="/editchartCurrency/:id" element={<EditpricesCurrency />} />


                <Route path="/corewalletbalance" element={<Corewalletbalance />} />
                <Route path="/corewalletbalance/POL" element={<CorePOLHistory />} />
                <Route path="/corewalletbalance/BNB" element={<CoreBNBHistory />} />
                <Route path="/corewalletbalance/ETH" element={<CoreETHHistory />} />
                <Route path="/corewalletbalance/SOL" element={<CoreSOLHistory />} />
                <Route path="/corewalletbalance/TRX" element={<CoreTRXHistory />} />

                <Route path="/support" element={<SupportTicket />} />
                <Route path="/ticket-details/:hashId/:id" element={<TicketChat />} />
                <Route path="/ticket-category" element={<TicketCategory />} />
                <Route path="/addticket-category" element={<AddTicketCategory />} />


                <Route path="/notification" element={<NotificationHistoryTable />} />






            </Route>
        </Route>
    )
);

